var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-result"},[_c('content-box',{attrs:{"min-height":'646px'}},[_c('scenario-list',{staticClass:"scenario-list",attrs:{"scenarioList":_vm.scenarioList},on:{"getTestResultList":_vm.getTestResults}}),_c('test-result-list',{staticClass:"test-list",attrs:{"testResultList":_vm.testResultList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }